import React from "react";

const MultiSelectIcon = ({ width = 16, height = 16, fill = "white", ...props }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.05575 10.9808C3.62892 10.8589 2.42958 10.2775 1.45775 9.2365C0.485917 8.1955 0 6.95 0 5.5C0 3.97433 0.53525 2.67625 1.60575 1.60575C2.67625 0.53525 3.97433 0 5.5 0C6.95 0 8.1955 0.484333 9.2365 1.453C10.2775 2.4215 10.8589 3.61925 10.9808 5.04625L9.3905 4.575C9.17383 3.675 8.70875 2.9375 7.99525 2.3625C7.28175 1.7875 6.45 1.5 5.5 1.5C4.4 1.5 3.45833 1.89167 2.675 2.675C1.89167 3.45833 1.5 4.4 1.5 5.5C1.5 6.45 1.78908 7.28333 2.36725 8C2.94542 8.71667 3.68133 9.18333 4.575 9.4L5.05575 10.9808ZM13.6403 15.1443L9.10575 10.6L8.01925 13.8845L5.5 5.5L13.8845 8.01925L10.6 9.10575L15.1443 13.6403L13.6403 15.1443Z"
        fill={fill}
      />
    </svg>
  );
};

export default MultiSelectIcon;

